import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=92d2b094&scoped=true"
import script from "./CategoriesView.vue?vue&type=script&lang=js"
export * from "./CategoriesView.vue?vue&type=script&lang=js"
import style0 from "./CategoriesView.vue?vue&type=style&index=0&id=92d2b094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d2b094",
  null
  
)

export default component.exports